import { cleanupSupabaseChannel, supabase } from '../supabaseClient'

export const ClientChatService = {
    async registerGuestVisitor({ sessionId, name, phone, email }) {
        const payload = {
            session_id: sessionId,
            name: name.trim(),
            mobile: phone ? phone.trim() : null,
            email: email ? email.trim().toLowerCase() : null
        }

        const { error } = await supabase
            .from('chat_guests')
            .upsert(payload, { onConflict: 'session_id' })

        if (error) {
            throw error
        }
    },

    async sendMessage({ content, contact_id, session_id, mode, attachments = [] }) {
        if (!content || !content.trim()) {
            throw new Error('Mensaje vacío')
        }

        const channel = mode === 'portal' ? 'portal' : 'web'

        const payload = {
            content: content.trim(),
            direction: 'inbound',
            channel,
            contact_id: contact_id || null,
            session_id: channel === 'web' ? session_id || null : null,
            status: 'sent',
            is_read: false,
            attachments: attachments && attachments.length ? attachments : []
        }

        const { data, error } = await supabase.from('messages').insert(payload).select().single()

        if (error) {
            throw error
        }

        return data
    },

    subscribeToMyMessages({ contact_id, session_id, callback }) {
        const realtimeFilter = contact_id
            ? `contact_id=eq.${contact_id}`
            : session_id
              ? `session_id=eq.${session_id}`
              : undefined

        const channel = supabase
            .channel(`public:messages:client-widget:${contact_id || session_id || 'all'}`)
            .on(
                'postgres_changes',
                {
                    event: 'INSERT',
                    schema: 'public',
                    table: 'messages',
                    filter: realtimeFilter
                },
                (payload) => {
                    const msg = payload?.new
                    if (!msg) return

                    const byContact = contact_id && msg.contact_id === contact_id
                    const bySession = session_id && msg.session_id && msg.session_id === session_id

                    if (byContact || bySession) {
                        callback(msg)
                    }
                }
            )
            .subscribe()

        return () => {
            cleanupSupabaseChannel(channel)
        }
    }
}
